export enum AnalyticsGraphGroupType {
  NONE = '',
  BY_DAY = 'day',
  BY_WEEK = 'week',
  BY_MONTH = 'month',
}
